import {initializeApp, FirebaseOptions, FirebaseApp} from 'firebase/app';
import {Auth, getAuth} from 'firebase/auth';
import MissingEnvironmentVariableException from '../exceptions/MissingEnvironmentVariableException';

if (!process.env.REACT_APP_FIREBASE_CONFIG) {
  throw new MissingEnvironmentVariableException('REACT_APP_FIREBASE_CONFIG');
}

const firebaseConfig: FirebaseOptions = JSON.parse(process.env.REACT_APP_FIREBASE_CONFIG);

// Initialize Firebase
const app: FirebaseApp = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth: Auth = getAuth(app);
export default app;
